import React from 'react';
import { useTranslation } from '../../i18n/useTranslation';
import './Contacts.css';

const Contacts = () => {
  const { t, phone } = useTranslation();

  const contactItems = [
    { icon: '📍', labelKey: 'contacts.address', valueKey: 'contacts.addressValue' },
    { icon: '📞', labelKey: 'contacts.phone', href: `tel:${phone.replace(/\s/g, '')}`, display: phone },
    { icon: '✉️', labelKey: 'contacts.email', href: 'mailto:powerautoservice.99@gmail.com', display: 'powerautoservice.99@gmail.com' },
  ];

  return (
    <section id="contacts" className="section section-gray">
      <div className="container">
        <h2 className="section-title" style={{ textAlign: 'center' }}>
          {t('contacts.title')}
        </h2>
        <p className="section-subtitle" style={{ textAlign: 'center', margin: '0 auto 48px' }}>
          {t('contacts.subtitle')}
        </p>

        <div className="contacts__grid">
          <div className="contacts__info">
            <div className="contacts__card">
              {contactItems.map((item, i) => (
                <div key={i} className="contacts__item">
                  <span className="contacts__icon">{item.icon}</span>
                  <div>
                    <strong>{t(item.labelKey)}</strong>
                    {item.href ? (
                      <p><a href={item.href}>{item.display}</a></p>
                    ) : (
                      <p>{t(item.valueKey)}</p>
                    )}
                  </div>
                </div>
              ))}

              <div className="contacts__item">
                <span className="contacts__icon">🕐</span>
                <div>
                  <strong>{t('contacts.schedule')}</strong>
                  <p>{t('contacts.weekdays')}</p>
                  <p>{t('contacts.nightSurcharge')}</p>
                </div>
              </div>
            </div>

            <div className="contacts__socials">
              <a
                href="https://t.me/PowerTemur"
                target="_blank"
                rel="noopener noreferrer"
                className="contacts__social"
              >
                ✈️ Telegram
              </a>
              <a
                href="https://www.instagram.com/onortushig"
                target="_blank"
                rel="noopener noreferrer"
                className="contacts__social"
              >
                📷 Instagram
              </a>
            </div>
          </div>

          <div className="contacts__map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d794.5922411207957!2d106.91710133607651!3d47.94259128327265!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5d9693a7296d7b2f%3A0x2e3998419ebf01a!2sPower%20auto%20service!5e0!3m2!1sru!2sru!4v1775635278275!5m2!1sru!2sru"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '489.25px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Maps"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contacts;
